const middleware = {}

middleware['redirectBasedOnRegex'] = require('../middleware/redirectBasedOnRegex.js')
middleware['redirectBasedOnRegex'] = middleware['redirectBasedOnRegex'].default || middleware['redirectBasedOnRegex']

export default middleware
